module.exports = __webpack_public_path__ + "static/media/belcolor__7.945f27b4.jpg";